import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { AttendeeSessionService } from "../../../../modules/shared/services/attendee-session.service";
import { CclPopupService, CclMessageService } from "certain-common-library";
import { FlashMessagesService } from "angular2-flash-messages";
import { Router } from "@angular/router";
import { CatalogService } from "../../../../modules/shared/services/catalog.service";

@Component({
    selector: "reset-password",
    templateUrl: "./reset-password.view.html",
    providers: []
})
export class ResetPasswordView implements OnInit {
    resetPasswordModal: any = {};
    loginConfig: any = {};
    isPopUp: boolean = false;
    constructor(
        private router: Router,
        public sharedService: SharedService,
        private attendeeSessionService: AttendeeSessionService,
        private popupService: CclPopupService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService
    ) {}

    ngOnInit() {
        this.isPopUp = this.router.url.includes("(popup:popup/forgotPassword)");
        this.loginConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.LOGIN_POPUP].config);
    }

    close() {
        this.popupService.hidePopup();
    }

    openPopup(item, $event) {
        this.popupService.hidePopup();
        setTimeout(() => {
            if ($event != null) {
                $event.stopPropagation();
            }
            let url = "";
            if (item == "login") {
                this.popupService.setPosition("center");
                this.popupService.setHeight("50%");
                this.popupService.setSize("small");
                this.popupService.togglePopup();
                this.sharedService.currentPopup = {
                    title: null,
                    navLinks: null,
                    saveMessage: "reg-login",
                    showFooter: false
                };
                url = "popup/login";
            }
            this.sharedService.navigateToOutlet("popup", url);
        }, 500);
    }

    savePassword() {
        if(this.resetPasswordModal.newPassword == this.resetPasswordModal.password) {
            this.resetPasswordModal.eventId = this.sharedService.event.id;
            this.resetPasswordModal.email = this.sharedService.resetPasswordDetails.email;
            this.attendeeSessionService.updatePassword(this.resetPasswordModal).subscribe((response) => {
                this.popupService.hidePopup();
                this._flashMessagesService.show(response['body']['successApiResponse'].message, {
                    cssClass: "alert-success"
                });
            },
            (err) => {
                var message = "";
                if (err.error.errorResponse != null && err.error.errorResponse.errors != null) {
                    err.error.errorResponse.errors.forEach((element) => {
                        message += element + "\n";
                    });
                }

                this._flashMessagesService.show(message, {
                    cssClass: "alert-danger"
                });
            })
        } else {
            this._flashMessagesService.show('New Password and Confirm Password should be same.', {
                cssClass: "alert-danger"
            });
        }
    }
}
